import { Injectable, Inject } from '@angular/core';
import { HttpClientHelper } from '../../../_service/http-helper';
//import { AppStore } from '../../../app.store';
//import { UsersState } from '../../../_model/user/user.reducer';
import { ApiUrlHelper } from '../../../_service/api-url-helper';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DailySignInService {
  user;
  sataus = true;
  value = 0;
  private bonusDataSource = new BehaviorSubject<any>(undefined);
  bonusData = this.bonusDataSource.asObservable();

  private newDataSource = new BehaviorSubject<any>(undefined);
  newData = this.newDataSource.asObservable();

  private signedOrNot = new BehaviorSubject<any>(false);
  signedStatus = this.signedOrNot.asObservable();

  constructor(
    private httpClientHelper: HttpClientHelper,
    private _apiHelper:ApiUrlHelper
    //@Inject(AppStore) private store: Store<UsersState>,
    // private apiUrlHelper: ApiUrlHelper,
  ) { }

  // readState() {
  //   const state: UsersState = this.store.getState()['users'] as UsersState;
  //   this.user = state.currentUser;
  // }

  getSignInData(id) {
    const apiURL = this._apiHelper.APIV3_ENDPOINT('api') + '/activity/getBonus';
    return this.httpClientHelper.get(apiURL);
  }

  setState(state) {
    this.bonusDataSource.next(state);
  }

  setNewState(state) {
    this.newDataSource.next(state);
  }

  afterSigned(signed) {
    this.signedOrNot.next(signed);
  }

  signInSubmit() {
    //this.readState();
    const body = {
      // uid: this.user.id,
      // token: this.user.token.token,
      // sign:this.user.token.sign,
      // expire:this.user.token.expire,
      // gid:this.user.token.gid
    };
    const apiURL = this._apiHelper.APIV3_ENDPOINT('api') + '/activity/reqBonus';
    // console.log(body);
    return this.httpClientHelper.post(apiURL, body, null);
  }
}
